import {
  TickerWrapper,
  TickerTrack,
  TickerItem,
} from "./PromoTickerBar.styles";

// Tekst i uključenost trake se podešavaju u Admin Panelu → Podešavanja
const PromoTickerBar = ({ visible, text }) => {
  if (!text?.trim()) {
    return null;
  }

  const items = Array.from({ length: 10 }, (_, i) => (
    <TickerItem key={i}>{text}</TickerItem>
  ));

  return (
    <TickerWrapper $visible={visible}>
      <TickerTrack>
        {items}
        {items}
      </TickerTrack>
    </TickerWrapper>
  );
};

export default PromoTickerBar;
